import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import React from 'react';
import { formatToPriceInDollars } from '../../../../../utils/FormatValue';
import { mockOpportunityRouteData } from '@pages/Opportunity-dashboard/opportunityTransactionsMock';
import { IRouteOpportunityData } from '@sp-types/transactionOpportunityType';

interface Props {
  data: IRouteOpportunityData[];
  closeDiv: () => void;
}

export const OpportunityRoutesDataCard: React.FC<Props> = ({ closeDiv, data }) => {
  return (
    <div className="p-4 flex flex-col overflow-visible shadow-custom gap-2 m-2 ">
      <div className="flex justify-between flex-row">
        <p className="text-lg">Transaction opportunities routes</p>
        <button className="text-blue-600 h-6 w-6 " onClick={() => closeDiv()}>
          <CloseRoundedIcon />
        </button>
      </div>
      <div className="flex flex-1 flex-col gap-2">
        {/* // Headings */}
        <div className=" bg-gray-50  py-2 ps-3   grid grid-cols-5  gap-4  border    overflow-hidden">
          {headings.map((item, index) => (
            <div key={index} className="col-span-1 truncate   ">
              <p className="text-sm text-secondary_text">{item}</p>
            </div>
          ))}
        </div>
        {/* // Table */}
        <div className="flex flex-1 flex-col relative gap-2 ">
          {data.map(({ buyingPrice, routeId, sellingPrice }, index) => {
            const routeDiff = sellingPrice - buyingPrice;
            return (
              <div
                className="bg-white  py-2  ps-3 grid grid-cols-5 relative border border-gray-300  gap-4   min-h-12 "
                key={index}
              >
                <div
                  style={{ borderLeft: `4px solid ${mockOpportunityRouteData[routeId].color}` }}
                  className={`  ps-2 col-span-2 truncate  content-center`}
                  title={mockOpportunityRouteData[routeId].name}
                >
                  {mockOpportunityRouteData[routeId].name}
                </div>
                <div className="col-span-1 truncate  content-center" title={formatToPriceInDollars(buyingPrice)}>
                  {formatToPriceInDollars(buyingPrice)}
                </div>
                <div className="col-span-1 truncate  content-center" title={formatToPriceInDollars(sellingPrice)}>
                  {formatToPriceInDollars(sellingPrice)}
                </div>

                <div
                  className={`col-span-1 truncate flex flex-row justify-between flex-1 items-center pe-2 content-center ${
                    routeDiff > 0 ? 'text-green-flat' : 'text-orange-500'
                  } `}
                  title={formatToPriceInDollars(routeDiff)}
                >
                  {formatToPriceInDollars(routeDiff, 1)}
                  {!index && <img className="h-5 w-5" src="./assets/icons/colored/Approved_status.svg" />}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const headings = ['Route', '', 'Buy price', 'Sell price', 'Route diff.'];
